import { useContext } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
} from '@chakra-ui/react';

import { L10nContext } from 'business-layer/contexts/L10nContext';
import { GenericKeyValue } from 'business-layer/types';

type ModalProps = {
  isOpen: boolean,
  onClose: () => void,
};

export const TocModal = ({
    isOpen,
    onClose,
    ...props
  }: ModalProps) => {
  const { labels, toc }: { labels: GenericKeyValue, toc: string } = useContext(L10nContext) as any;

  return (
    <Modal
      blockScrollOnMount={false}
      isOpen={isOpen}
      onClose={onClose}
      scrollBehavior="inside"
      size={'3xl'}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader
          data-testid="toc-modal-header"
          textTransform="uppercase"
          fontSize={'md'}
        >
          {labels.toc || 'Terms and Conditions'}
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody pt={6} pb={6} data-testid="toc-modal-body" >
          <div dangerouslySetInnerHTML={{__html: `${toc || ''}`}} />
        </ModalBody>
        <ModalFooter />
      </ModalContent>
    </Modal>
  );
};

